module.exports = __webpack_public_path__ + "img/shoppies-demo.cd124c1a.gif";